export default {
  table: {
    date: 'Data de criação',
    type: 'Tipo de arquivo',
    name: 'Nome',
    description: 'Descrição',
    title: 'Novo arquivo'
  }
}